import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IBusinessRuleLine } from '../../../@types/model/masterData/businessRuleLine/businessRuleLine';
import { IBusinessRuleLineUpsert } from '../../../@types/model/masterData/businessRuleLine/businessRuleLineUpsert';

export default class BusinessRuleLineHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(businessRuleIds : Array<number>) : AxiosPromise<Array<IBusinessRuleLine>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/BusinessRuleLine/GetList`, {
            params: {
                businessRuleIds
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IBusinessRuleLineUpsert, type : 'Add' | 'Edit') : AxiosPromise<IBusinessRuleLine> => {
        return axios.post(`${API_URL}/v1/MasterData/BusinessRuleLine/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise<IBusinessRuleLine> => {
        return axios.delete(`${API_URL}/v1/MasterData/BusinessRuleLine/Delete`, {
            params: { id },
        });
    }
}